import Vue from 'vue';
import Router from 'vue-router';
import NotFound from '@/components/404';
import Login from '@/components/Auth/Login';
import Forgot from '@/components/Auth/Forgot';
import Layout from '@/components/Layout/Index';
import Test from '@/components/Pages/Test/Test';
import Register from '@/components/Auth/Register';
import BlackListed from '@/components/BlackListed';
import Setup from '@/components/Pages/Setup/Index';
import ResetPassword from '@/components/Auth/Reset';
import TestIndex from '@/components/Pages/Test/Index';
import Status from '@/components/Pages/Profile/Status';
import Profile from '@/components/Pages/Profile/Index';
import TakeTest from '@/components/Pages/Test/TakeTest';
import BasicSetup from '@/components/Pages/Setup/Basic';
import DemoSetup from '@/components/Pages/Setup/Demo';
import Dashboard from '@/components/Pages/Dashboard/Index';
import EditWork from '@/components/Pages/Profile/EditWork';
import EditBasic from '@/components/Pages/Profile/EditBasic';
import EditAbout from '@/components/Pages/Profile/EditAbout';
import AcademicSetup from '@/components/Pages/Setup/Academic';
import Media from '@/components/Pages/Profile/ProfilePicture';
import HomeDashboard from '@/components/Pages/Dashboard/Home';
import JobsDashboard from '@/components/Pages/Dashboard/Jobs';
import InboxDashboard from '@/components/Pages/Dashboard/Inbox';
import AllTickets from '@/components/Pages/Tickets/AllTickets';
import PreviewProfile from '@/components/Layout/PreviewProfile';
import EducationSetup from '@/components/Pages/Setup/Education';
import ClassTicket from '@/components/Pages/Tickets/ClassTicket';
import Credentials from '@/components/Pages/Profile/Credentials';
import EditSocials from '@/components/Pages/Profile/EditSocials';
import EditProfile from '@/components/Pages/Profile/EditProfile';
import TestComponent from '@/components/Pages/Test/TestComponent';
import CycleLogs from '@/components/Pages/ClassSession/CycleLogs';
import HowItWorksSetup from '@/components/Pages/Setup/HowItWorks';
import ClassTickets from '@/components/Pages/Tickets/ClassTickets';
import TutorTickets from '@/components/Pages/Tickets/TutorTickets';
import EditLocation from '@/components/Pages/Profile/EditLocation';
import Verification from '@/components/Pages/Profile/Verification';
import EditTeaching from '@/components/Pages/Profile/EditTeaching';
import TutorClass from '@/components/Pages/ClassSession/TutorClass';
import ClassesDashboard from '@/components/Pages/Dashboard/Classes';
import ProfileDashboard from '@/components/Pages/Dashboard/Profile';
import EditEducation from '@/components/Pages/Profile/EditEducation';
import VerificationSetup from '@/components/Pages/Setup/Verification';
import EarningsDashboard from '@/components/Pages/Dashboard/Earnings';
import TutorClasses from '@/components/Pages/ClassSession/TutorClasses';
import DayAvailability from '@/components/Pages/Profile/DayAvailabiltity';
import TestStatus from '@/components/Pages/Profile/AcademicInfo/TestStatus';
import TutoringJobs from '@/components/Pages/TutoringJobs/TutoringJobs';
import TutoringJob from '@/components/Pages/TutoringJobs/TutoringJob';
import PersonalInfo from '@/components/Pages/Dashboard/partials/PersonalInfo';
import AcademicInfo from '@/components/Pages/Dashboard/partials/AcademicInfo';
import GettingStartedDashboard from '@/components/Pages/Dashboard/GettingStarted';
import EducationalInfo from '@/components/Pages/Dashboard/partials/EducationalInfo';
import SubjectAbility from '@/components/Pages/Profile/AcademicInfo/SubjectsAbility';
import AllSubjectProfiles from '@/components/Pages/Profile/AcademicInfo/AllSubjectProfiles';
import EditSubjectProfile from '@/components/Pages/Profile/AcademicInfo/EditSubjectProfile';
import Inboxes from '@/components/Pages/Inbox/Index';
import IndexTest from '@/components/Pages/Inbox/IndexTest';
Vue.use(Router);

export default new Router({
  routes: [{
      path: '/',
      name: 'default',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: Forgot,
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/reset-password/:token',
      name: 'reset-password',
      component: ResetPassword,
    },
    {
      path: '',
      name: 'layout',
      meta: {
        auth: true
      },
      redirect: 'welcome-setup',
      component: Layout,
      children: [{
          path: 'setup',
          name: 'setup',
          redirect: 'setup/welcome',
          component: Setup,
          children: [{
              path: 'basic',
              name: 'basic-setup',
              component: BasicSetup,
              redirect: 'basic/personal-info',
              children: [{
                  path: 'personal-info',
                  name: 'personal-info-setup',
                  component: EditBasic,
                },
                {
                  path: 'location-info',
                  name: 'location-info-setup',
                  component: EditLocation,
                },
                {
                  path: 'bio',
                  name: 'bio-setup',
                  component: EditAbout,
                },
              ],
            },
            {
              path: 'education',
              name: 'education-setup',
              component: EducationSetup,
              redirect: 'education/educational-info',
              children: [{
                  path: 'educational-info',
                  name: 'educational-info-setup',
                  component: EditEducation,
                },
                {
                  path: 'teaching-info',
                  name: 'teaching-info-setup',
                  component: EditTeaching,
                },
                {
                  path: 'work-experience',
                  name: 'work-experience-setup',
                  component: EditWork,
                },
              ],
            },
            {
              path: 'welcome',
              name: 'welcome-setup',
              component: DemoSetup,
            },
            {
              path: 'verification',
              name: 'verification-setup',
              component: VerificationSetup,
            },
            {
              path: 'tutoring-info',
              name: 'academic-setup',
              component: AcademicSetup,
              redirect: 'tutoring-info/availability',
              children: [{
                  path: 'availability',
                  name: 'availability-info',
                  component: DayAvailability,
                },
                {
                  path: 'subjects',
                  name: 'subject-classes',
                  component: SubjectAbility,
                },
                {
                  path: 'test',
                  name: 'test-index',
                  component: TestIndex,
                  redirect: 'test/status',
                  children: [{
                      path: 'status',
                      name: 'test-status',
                      component: TestStatus,
                    },
                    {
                      path: 'take/:abilitySubject',
                      name: 'test-take',
                      component: TakeTest,
                      props: true,
                    },
                  ],
                },
                {
                  path: 'profiles',
                  name: 'subject-profiles',
                  component: AllSubjectProfiles,
                  children: [{
                    path: ':ability_subject_id',
                    name: 'subject-profiles-edit',
                    component: EditSubjectProfile,
                    props: true,
                  }, ],
                },
              ],
            },
            {
              path: 'how-it-works',
              name: 'how-it-works-setup',
              component: HowItWorksSetup,
            },
          ],
        },
        {
          path: 'dashboard',
          name: 'dashboard',
          redirect: 'dashboard/get-started',
          component: Dashboard,
          children: [{
              path: 'get-started',
              name: 'home-dashboard',
              component: GettingStartedDashboard,
            },
            {
              path: 'home',
              name: 'getting-started-dashboard',
              component: HomeDashboard,
              props: ({
                query
              }) => ({
                period: query.period
              }),
            },
            {
              path: 'inbox',
              name: 'inbox-dashboard',
              component: InboxDashboard,
              children: [{
                path: '/',
                name: 'all-inbox',
                component: Inboxes,
              }, ],
            },
            {
              path: 'inbox-test',
              name: 'inbox-dashboard-test',
              component: IndexTest,
              children: [{
                path: '/',
                name: 'all-inbox',
                component: Inboxes,
              }, ],
            },
            {
              path: 'earnings',
              name: 'earnings-dashboard',
              component: EarningsDashboard,
            },
            {
              path: 'classes',
              name: 'classes-dashboard',
              component: ClassesDashboard,
              redirect: 'classes/all',
              children: [{
                  path: 'all',
                  name: 'tutor-classes',
                  component: TutorClasses,
                },
                {
                  path: ':id',
                  name: 'tutor-class',
                  component: TutorClass,
                  props: true,
                },
                {
                  path: ':id/logs',
                  name: 'class-logs',
                  component: CycleLogs,
                  props: true,
                },
              ],
            },
            {
              path: 'tickets',
              name: 'tickets-dashboard',
              component: TutorTickets,
              redirect: 'tickets/all',
              children: [{
                  path: 'all',
                  name: 'all-tickets',
                  component: AllTickets,
                },
                {
                  path: 'class/:id',
                  name: 'class-tickets',
                  component: ClassTickets,
                  props: true,
                },
                {
                  path: ':id',
                  name: 'class-ticket',
                  component: ClassTicket,
                  props: true,
                },
              ],
            },
            {
              path: 'jobs',
              name: 'jobs-dashboard',
              component: JobsDashboard,
              redirect: 'jobs/tutoring-jobs',
              children: [{
                  path: 'tutoring-jobs',
                  name: 'tutoring-jobs',
                  component: TutoringJobs,
                },
                {
                  path: 'tutoring-jobs/:id',
                  name: 'tutoring-job',
                  component: TutoringJob,
                  props: true,
                },
              ],
            },
            {
              path: 'profile',
              name: 'profile-dashboard',
              component: ProfileDashboard,
              redirect: 'profile/personal-info',
              children: [{
                  path: 'personal-info',
                  name: 'personal-info-profile-dashboard',
                  component: PersonalInfo,
                },
                {
                  path: 'educational-info',
                  name: 'educational-info-profile-dashboard',
                  component: EducationalInfo,
                },
                {
                  path: 'verification',
                  name: 'verification-profile-dashboard',
                  component: VerificationSetup,
                },
                {
                  path: 'academic-info',
                  name: 'academic-info-profile-dashbard',
                  component: AcademicInfo,
                  children: [{
                      path: 'test',
                      name: 'test-index-dashboard',
                      component: TestIndex,
                      redirect: 'test/status',
                      children: [{
                          path: 'status',
                          name: 'test-status-dash',
                          component: TestStatus,
                        },
                        {
                          path: 'take/:abilitySubject',
                          name: 'test-take-dash',
                          component: TakeTest,
                          props: true,
                        },
                      ],
                    },
                    {
                      path: 'profiles',
                      name: 'subject-profiles-dash',
                      component: AllSubjectProfiles,
                      children: [{
                        path: ':ability_subject_id',
                        name: 'subject-profiles-edit-dash',
                        component: EditSubjectProfile,
                        props: true,
                      }, ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: '/preview/:tutor',
      name: 'preview-profile',
      component: PreviewProfile,
      props: true,
    },
    {
      path: '/t/:test',
      name: 'test',
      component: Test,
      props: true,
      // children: [
      //   {
      //     path: ':question',
      //     name: 'test-question',
      //     component: TestComponent,
      //     props: true,
      //   },
      // ],
    },
    {
      path: 'blacklisted',
      name: 'blacklisted',
      component: BlackListed,
    },
    {
      path: '*',
      component: NotFound,
    },
  ],
  // base: 'tutors/',
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior: () => ({
    y: 0
  }),
});



// WEBPACK FOOTER //
// ./src/router/index.js